import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {Wertemenge} from '../../../models/uiArtefakt';
import {FondsService} from '../../../services/fonds.service';
import {tap} from 'rxjs';
import {take} from 'rxjs/operators';

@Component({
    selector: 'lv-individuelle-portfolioloesung',
    templateUrl: './individuelle-portfolioloesung.component.html',
    styleUrls: ['./individuelle-portfolioloesung.component.scss'],
    standalone: false
})
export class IndividuellePortfolioloesungComponent implements AfterViewInit {
  private _uiArtefakt: Wertemenge;

  constructor(private _fondsService: FondsService,
              private _renderer: Renderer2, private _element: ElementRef) {}

  get uiArtefakt(): Wertemenge {
    return this._uiArtefakt;
  }

  @Input()
  set uiArtefakt(uiArtefakt: Wertemenge) {
    this._uiArtefakt = uiArtefakt;
    if ('/individuellePortfolioloesung' === this._uiArtefakt.FeldnameExtern) {
      this._fondsService.getFondsgruppenInProdukt(this._uiArtefakt).pipe(take(1)).subscribe();
    }
    if ('/individuellePortfolioloesungZuzahlung' === this._uiArtefakt.FeldnameExtern) {
      this._fondsService.getFondsgruppenInProdukt(this._uiArtefakt).pipe(take(1)).subscribe();
    }
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }
}
